export function getLang(): string {
  return localStorage.getItem('worldviews-lang') as string;
}

export const setLang = (lang: string) => {
  localStorage.setItem('worldviews-lang', lang);
};
